<template>
    <div id="addEditTripsPhotos_wrapper">

        <b-tabs class="mb-lg" pills card align="center">
            <b-tab title="Upload Images" active>
                <div class="con-tab-ejemplo">
                    <div class="example-full">
                        <!--                <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">-->
                        <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
                            <h3>Drop files to upload</h3>
                        </div>
                        <div class="upload">
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                    <tr>
                                        <th>Thumb</th>
                                        <th>Name</th>
                                        <th>Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="!files.length">
                                        <td colspan="7">
                                            <div class="text-center p-5">
                                                <h4>Drop files anywhere to upload<br/>or</h4>
                                                <label :for="name" class="btn btn-lg btn-primary">Select Files</label>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-for="(file, index) in files" :key="file.id">
                                        <td>
                                            <img v-if="file.thumb" :src="file.thumb" width="100" height="auto"/>
                                            <span v-else>No Image</span>
                                        </td>
                                        <td>
                                            <div class="filename">
                                                {{file.name}}
                                            </div>
                                            <div class="progress" v-if="file.active || file.progress !== '0.00'">
                                                <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>
                                            </div>
                                        </td>
                                        <td v-if="file.error">{{file.error}}</td>
                                        <td v-else-if="file.success" class="text-success">success</td>
                                        <td v-else-if="file.active" class="text-info">active</td>
                                        <td v-else></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="example-foorer">
                                <div class="btn-group">
                                    <file-upload
                                            class="btn btn-primary dropdown-toggle"

                                            :extensions="extensions"
                                            :accept="accept"
                                            :multiple="multiple"
                                            :directory="directory"
                                            :custom-action="customAction"
                                            :size="size || 0"
                                            :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                            :drop="drop"
                                            :drop-directory="dropDirectory"
                                            :add-index="addIndex"
                                            v-model="files"
                                            @input-filter="inputFilter"
                                            @input-file="inputFile"
                                            ref="upload">

                                        <i class="fa fa-plus"></i>
                                        Select
                                    </file-upload>
                                    <div class="dropdown-menu">
                                        <label class="dropdown-item" :for="name">Add files</label>
                                        <a class="dropdown-item" href="#" @click="onAddFolader">Add folder</a>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>


                </div>


                <div class="alert alert-danger" v-if="error">
                    <button type="button" aria-hidden="true" class="close">×</button>
                    <span>{{error}}</span>
                </div>


            </b-tab>
            <b-tab title="Manage Album">
                <p class="mb-sm">
                    <b-button
                            variant="danger"
                            @click="openConfirmDelete()"
                            v-bind:disabled="selectedImagesCount===0">
                        Delete {{ selectedImagesCount}} images
                    </b-button>

                    <vue-select-image :dataImages="albumImagesBaseURL()"
                                      :is-multiple="true"
                                      :selectedImages="initialSelected"
                                      @onselectmultipleimage="onSelectMultipleImage">
                    </vue-select-image>

                </p>
            </b-tab>

        </b-tabs>
    </div>
</template>

<script>
  import firebase from 'firebase'

  const fb = require('../firebaseConfig.js')
  import { mapState } from 'vuex'
  import fetch from 'node-fetch'
  /////////////
  import Vue from 'vue'

  import IcFirebaseUploader from 'ic-firebase-uploader'
  import 'ic-firebase-uploader/dist/ic-firebase-uploader.min.css'
  import { mediasCollection } from '../firebaseConfig'
  import swal from 'sweetalert2'
  ////////////////////
  import VueUploadComponent from 'vue-upload-component'

  Vue.component('ic-firebase-uploader', IcFirebaseUploader)
  /////////////////
  import gmapsInit from '../googleMapsConfig'

  /////////////////
  const CommonLib = require('../lib/Common')
  /////////////////
  import UIHelpersMixins from '../mixims/UIHelpersMixins'

  export default {
    mixins:
                [
                  UIHelpersMixins,
                ],
    props:      {},
    components: {
      FileUpload: VueUploadComponent,
    },
    data ()
    {
      return {
        openConfirmActive: false,

        initialSelected: [],
        albumImages:     [],

        selectedImages: [],

        // Set pos tab
        openLocalisationActive: false,
        selectImageAddPosition: null,

        files:         [],
        accept:        'image/png,image/gif,image/jpeg,image/webp',
        extensions:    'gif,jpg,jpeg,png,webp',
        // extensions: ['gif', 'jpg', 'jpeg','png', 'webp'],
        // extensions: /\.(gif|jpe?g|png|webp)$/i,
        minSize:       1024,
        size:          1024 * 1024 * 10,
        multiple:      true,
        directory:     false,
        drop:          true,
        dropDirectory: true,
        addIndex:      false,
        thread:        3,
        name:          'file',

        uploadAuto: true,
      }
    },
    mounted:    function () {

      gmapsInit().then(function () {
      })

      this.handleAlbumReload()
    },
    methods:    {
      customAction (file, component)
      {
        var that = this
        return new Promise((resolve, reject) => {

          const fullPath = that.folderPath + '/' + file.name

          const rootRef = firebase.storage().ref()
          const fileRef = rootRef.child(fullPath)

          fileRef.put(file.file)
            .then(() => fileRef.getDownloadURL())
            .then(downloadUrl => {

              file.downloadUrl = downloadUrl
              file.fullPath    = fullPath

              that.onUpload(file.fullPath, file.file).then(function (file) {

                resolve()
              }).catch(function (err) {
                reject(err)

              })

            })
            .catch(err => {
              console.error(err)
              this.$emit('error', err)
            })

        })
      },

      getStorage ()
      {
        return firebase.storage()
      },
      openConfirmDelete ()
      {

        var that = this
        swal({
          title:              'Are you sure?',
          text:               'Are you sure you want to delete ' + this.selectedImages.length + ' images ?',
          type:               'warning',
          showCancelButton:   true,
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass:  'btn btn-danger',
          confirmButtonText:  'Yes, delete it!',
          buttonsStyling:     false
        }).then((result) => {
          if (result.value)
          {
            that.acceptConfirmDelete()
          }

        })
      },
      acceptConfirmDelete ()
      {
        var that = this
        this.selectedImages.forEach(function (k, v) {

          fb.mediasCollection.doc(k.id).get().then(function (doc) {

            if (!doc.exists)
            {
              return
            }

            fb.storage.ref().child(doc.data().fullPath).delete().then(function () {

            }).catch(function (error) {

            })

            if (doc.data().thumbsPath)
            {
              for (var k in doc.data().thumbsPath)
              {
                var path = doc.data().thumbsPath[k]

                fb.storage.ref().child(path).delete().then(function () {

                }).catch(function (error) {

                })
              }
            }

            fb.mediasCollection.doc(doc.id).delete()
              .then(ref => {
                that.notifyVue('success', ' Image deleted!')
                that.selectedImages = []
              }).catch(err => {
              that.notifyVue('danger', err)

              that.selectedImages = []
              console.log(err)
            })

          })

        })

        this.selectedImages = []
      },

      getFileName (file)
      {
        return file.name + '_' + Math.floor(Math.random() * 1000 * 1000)
      },
      onUpload (fullPath, file)
      {
        var that = this
        return new Promise((resolve, reject) => {

          fb.mediasCollection.add({
            createdOn: new Date(),
            updatedOn: new Date(),
            metadata:  {
              lastModified: file.lastModifiedDate,
              name:         file.name,
              size:         file.size,
              type:         file.type,
            },
            fullPath:  fullPath,
            uid:       that.currentUser.uid,
            tripId:    that.selectedTrip.id,

          }).then(ref => {
            resolve(file)

          }).catch(err => {

            reject(err)
            console.log(err)
          })
        })

      },
      onDelete ({doDelete})
      {
        doDelete()
      },

      handleAlbumReload ()
      {
        var that = this

        fb.mediasCollection.where('tripId', '==', this.selectedTrip.id).orderBy('capturedOn', 'asc')
          .onSnapshot(function (querySnapshot) {

            that.albumImages           = []
            that.albumImagesGPS        = []
            that.albumImagesWithoutGPS = []

            querySnapshot.forEach(function (doc) {

              var data = doc.data()
              if (data.thumbsPath)
              {
                var img = {
                  id:         doc.id,
                  src:        CommonLib.getImageURL(data.thumbsPath[256]),
                  alt:        data.metadata.name,
                  latitude:        data.metadata.latitude,
                  longitude:        data.metadata.longitude,
                  capturedOn: data.capturedOn,
                }

                that.albumImages.push(img)

                if (data.metadata.latitude &&
                  data.metadata.longitude)
                {
                  that.albumImagesGPS.push(img)
                } else
                {
                  that.albumImagesWithoutGPS.push(img)
                }
              }

            })

          })
      },
      onSelectMultipleImage (selectedImages)
      {
        this.selectedImages = selectedImages
      },

      albumImagesBaseURL ()
      {
        return this.albumImages
      },
      albumImagesWithGPS ()
      {
        return this.albumImagesGPS
      },

      imagesWithoutGPS ()
      {
        return this.albumImagesWithoutGPS
      },

      inputFilter (newFile, oldFile, prevent)
      {
        if (newFile && !oldFile)
        {
          // Before adding a file
          // 添加文件前
          // Filter system files or hide files
          // 过滤系统文件 和隐藏文件
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name))
          {
            return prevent()
          }
          // Filter php html js file
          // 过滤 php html js 文件
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name))
          {
            return prevent()
          }

        }
        if (newFile && (!oldFile || newFile.file !== oldFile.file))
        {
          // Create a blob field
          // 创建 blob 字段
          newFile.blob = ''
          let URL      = window.URL || window.webkitURL
          if (URL && URL.createObjectURL)
          {
            newFile.blob = URL.createObjectURL(newFile.file)
          }
          // Thumbnails
          // 缩略图
          newFile.thumb = ''
          if (newFile.blob && newFile.type.substr(0, 6) === 'image/')
          {
            newFile.thumb = newFile.blob
          }
        }
      },
      // add, update, remove File Event
      inputFile (newFile, oldFile)
      {
        if (newFile && oldFile)
        {
          // update
          if (newFile.active && !oldFile.active)
          {
            // beforeSend
            // min size
            if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize)
            {
              this.$refs.upload.update(newFile, {error: 'size'})
            }
          }
          if (newFile.progress !== oldFile.progress)
          {
            // progress
          }
          if (newFile.error && !oldFile.error)
          {
            // error
          }
          if (newFile.success && !oldFile.success)
          {
            // success
          }
        }
        if (!newFile && oldFile)
        {
          // remove
          if (oldFile.success && oldFile.response.id)
          {
            // $.ajax({
            //   type: 'DELETE',
            //   url: '/upload/delete?id=' + oldFile.response.id,
            // })
          }
        }
        // Automatically activate upload
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error)
        {
          if (this.uploadAuto && !this.$refs.upload.active)
          {
            this.$refs.upload.active = true
          }
        }
      },
      alert (message)
      {
        alert(message)
      },

      // add folader
      onAddFolader ()
      {
        if (!this.$refs.upload.features.directory)
        {
          this.alert('Your browser does not support')
          return
        }
        let input             = this.$refs.upload.$el.querySelector('input')
        input.directory       = true
        input.webkitdirectory = true
        this.directory        = true
        input.onclick         = null
        input.click()
        input.onclick = (e) => {
          this.directory        = false
          input.directory       = false
          input.webkitdirectory = false
        }
      },

    }, // methods
    computed:   {
      currentUser ()
      {
        return this.$store.getters.currentUser
      },

      selectedTrip ()
      {
        return this.$store.getters.selectedTrip
      },

      folderPath ()
      {
        return 'trips/' + this.selectedTrip.id + '/medias'
      },

      isAuthenticated ()
      {
        return this.$store.getters.isAuthenticated
      },
      error ()
      {
        return this.$store.state.error
      },
      loading ()
      {
        return this.$store.state.loading
      },
      selectedImagesCount ()
      {
        return this.selectedImages.length
      },
      imageCount ()
      {
        return this.albumImages.length
      },
      imageWithGPSCount ()
      {
        return this.albumImagesGPS.length
      },
    },
    watch:      {
      selectedTrip: function (val) {

        if(val)
        {
          this.handleAlbumReload()
        }
      },

    },

  }
</script>


<style>
    .example-full .btn-group .dropdown-menu {
        display: block;
        visibility: hidden;
        transition: all .2s
    }

    .example-full .btn-group:hover > .dropdown-menu {
        visibility: visible;
    }

    .example-full label.dropdown-item {
        margin-bottom: 0;
    }

    .example-full .btn-group .dropdown-toggle {
        margin-right: .6rem
    }

    .example-full .filename {
        margin-bottom: .3rem
    }

    .example-full .btn-is-option {
        margin-top: 0.25rem;
    }

    .example-full .example-foorer {
        padding: .5rem 0;
        border-top: 1px solid #e9ecef;
        border-bottom: 1px solid #e9ecef;
    }

    .example-full .edit-image img {
        max-width: 100%;
    }

    .example-full .edit-image-tool {
        margin-top: .6rem;
    }

    .example-full .edit-image-tool .btn-group {
        margin-right: .6rem;
    }

    .example-full .footer-status {
        padding-top: .4rem;
    }

    .example-full .drop-active {
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        position: fixed;
        z-index: 9999;
        opacity: .6;
        text-align: center;
        background: #000;
    }

    .example-full .drop-active h3 {
        margin: -.5em 0 0;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: #fff;
        padding: 0;
    }
</style>


<style lang="css" scoped>

    #addEditTripsPhotos_wrapper {
        overflow: scroll;
        height: 399px;
    }
</style>